<template lang="pug">
    .marketing-tabs
        tabs(:items="tabs" :active-tab="$route.fullPath" @click="activateTab")
        slot
</template>

<i18n>
{
    "de": {
        "Statistics": "Statistiken",
        "Campaigns": "Kampagnen",
        "Meta Pixel": "Meta Pixel",
        "Newsletters": "Newsletter",
        "Subscription Topics": "Abonnement-Themen",
        "Coupons": "Gutscheine"
    }
}
</i18n>

<script>
import Tabs from '@/components/Tabs';

import { checkRestrictions } from '@/helpers'
import { useAuthStore, useSetupStore } from '@/stores'

export default {
    name: 'MarketingTabs',
    components: {
        Tabs
    },
    computed: {
        tabs() {
            let tabs = [];

            if (checkRestrictions(['statistics'])) {
                tabs.push({
                    name: this.$t('Statistics'),
                    path: '/marketing/statistics',
                    icon: {
                        name: 'chart-bar',
                        group: 'fas'
                    }
                })
            }

            if (this.enabledExtensions.includes('marketing') && checkRestrictions(['ex:marketing', 'ex:marketing:campaigns'])) {
                tabs.push({
                    name: this.$t('Campaigns'),
                    path: '/marketing/campaigns',
                    icon: {
                        name: 'bullhorn',
                        group: 'fas'
                    }
                });
            }

            if (this.enabledExtensions.includes('marketing') && checkRestrictions(['ex:marketing', 'ex:marketing:meta-pixel'])) {
                tabs.push({
                    name: this.$t('Meta Pixel'),
                    path: '/marketing/meta-pixel',
                    icon: {
                        name: 'crosshairs',
                        group: 'fas'
                    }
                });
            }

            if (this.enabledExtensions.includes('marketing') && checkRestrictions(['ex:marketing', 'ex:marketing:google-tag-manager'])) {
                tabs.push({
                    name: this.$t('Google Tag Manager'),
                    path: '/marketing/google-tag-manager',
                    icon: {
                        name: 'tags',
                        group: 'fas'
                    }
                });
            }

            if (this.enabledExtensions.includes('newsletter') && checkRestrictions(['ex:newsletter'])) {
                tabs.push({
                    name: this.$t('Newsletters'),
                    path: '/marketing/newsletters',
                    icon: {
                        name: 'envelope',
                        group: 'far'
                    }
                });

                if (checkRestrictions(['ex:newsletter', 'ex:newsletter:topics'])) {
                    tabs.push({
                        name: this.$t('Subscription Topics'),
                        path: '/marketing/newsletter-subscription-topics',
                        icon: {
                            name: 'list',
                            group: 'fas'
                        }
                    });
                }
            }

            if (this.enabledExtensions.includes('shop') && checkRestrictions(['ex:shop', 'ex:shop:coupons'])) {
                tabs.push({
                    name: this.$t('Coupons'),
                    path: '/marketing/coupons',
                    icon: {
                        name: 'money-check',
                        group: 'fas'
                    }
                })
            }

            return tabs;
        },
        isSuperUser() {
            return useAuthStore().isSuperUser;
        },
        isOwner() {
            return useAuthStore().isOwner;
        },
        rights() {
            return useAuthStore().rights;
        },
        enabledExtensions() {
            return useSetupStore().enabledExtensions;
        },
        setupStore() {
            return useSetupStore()
        }
    },
    methods: {
        activateTab(item) {
            return this.setupStore.activateTab(item)
        }
    }
};
</script>
